import React from "react";
import "./TxnLookup.css";
import { useSelector } from "react-redux";

function DummyTable() {
  const role=useSelector(store=>store.userReducer.role)
  return (
    <div>
      <div className="dummy-out">
        {(role=="super" || role=="operation" || role == "subSuper")&&(
          <div className="dummy-2">Org Name</div>
         
        ) }
         {(role=="super" || role=="operation" || role == "subSuper")&&(
          <div className="dummy-2">PG Name</div>
         
        ) }
        <div className="dummy-2">Transfer Mode</div>
        <div className="dummy-2">Txn Type</div>
        <div className="dummy-2">Status</div>
        <div className="dummy-2">Transaction Time</div>
        <div className="dummy-2">Ref Id</div>
        <div className="dummy-2">Amount</div>
        <div className="dummy-2">Commision</div>
        <div className="dummy-2">Closing Balance</div>
        {/* <div className="dummy-2">Action</div> */}
      </div>

      <div className="no-data">
        <div className="no-data-2">
          <p>No Data Found</p>
        </div>
      </div>
    </div>
  );
}

export default DummyTable;
